import ColorService from './ColorService';
import ColorInitializer from './ColorInitializer';
import { COLORS, CONSTANT_COLORS, THEME_COLORS } from './constants';

/**
 * Initialize color variables for the application
 * @param {string} userId - Optional user ID to load user-specific colors
 * @returns {Promise<boolean>} - Whether user-specific colors were applied
 */
export async function initializeColors(userId) {
  try {
    ColorService.applyColors(ColorService.getDefaultColors());
    
    if (userId) {
      const userColors = await ColorService.getUserColorPreferencesWithCache(userId);
      if (userColors) {
        ColorService.applyColors(userColors);
        return true;
      }
    }
    
    ColorService.applyConstantColors();
    
    return false;
  } catch (error) {
    console.error('Failed to initialize colors:', error);
    ColorService.applyColors(ColorService.getDefaultColors());
    ColorService.applyConstantColors();
    return false;
  }
}

export {
  ColorService,
  ColorInitializer,
  COLORS,
  CONSTANT_COLORS,
  THEME_COLORS
};